import { OptionSubCategory, tryLoadAllFullOptionsSync } from 'owa-options-core';

export default function shouldDisableSaveButton(currentSubcategory: OptionSubCategory): boolean {
    const options = tryLoadAllFullOptionsSync(currentSubcategory);
    return (
        !options ||
        options
            .filter(option => option.fullOptionFormSettings.isDirty())
            .reduce(
                (state, option) =>
                    state &&
                    !!option.fullOptionFormSettings.disableSave &&
                    option.fullOptionFormSettings.disableSave(),
                true
            )
    );
}
